import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useGetUserData } from "../../hooks/useGetUserData";
import { NetworkStatusAlert, NetworkStatusBadge } from "../NetworkBadge/NetworkBadge";
import { useIsMobile } from "../../hooks/use-mobile";
import { useCenterQuery } from "../../hooks/useCenterQuery";

// Page title mapping

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [aiChatOpen, setAiChatOpen] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const { data, isLoading } = useGetUserData();

    const {data:centerData}=useCenterQuery(data?.slug)
    console.log(centerData,"centerData");
    
    const location = useLocation();
    const isMobile = useIsMobile();
    const pageTitles = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/insights": "Insights",
    "/clinics": "Clinics Management", 
    "/clinics/new": "Add New Clinic",
    "/clinics/edit": "Edit Clinic",
    "/schedule": "Schedule",
    "/availability": "Availability Hours",
    "/form-builder": "Form Builder",
    "/patients": "Patients",
    "/bookings": "Bookings Management",
    "/Services": "Services",
    "/ads": "Ads",
    "/blogs": "Blogs",
    "/packages": "Packages",
    "/sub": "Subscription",
    "/contact": "Contact Us",
    "/excuse": "Excuse Management",
    "/ovr":"OVR Management",
    "/news":"News Management",
    "/specializations":"Specializations Management",
    "/facilities":"Facilities Management",
    "/equipments":"Equipments Management",
    "/suppliers"    :"Contracts ",
    "/vacations":"Vacations Management",
    "/Secertaries":"Secertaries Management",
    "/employees"    :"Employees Management",
    "/doctors": "Doctors Management",
    "/services-analysis":"Services Statistics",
    "/clinics-performance": `Center Performance`,
    "/all-bookings": "All Bookings",
    "/external-consultant": "External Consultant",
    "/scanQr": "Scan QR Code",
    "/QrGeneration": "QR Code Generation",
};

    const getPageTitle = (path) => {
        if (pageTitles[path]) return pageTitles[path];
        
        if (path.includes('/edit/')) return "Edit";
        if (path.includes('/view/')) return "View Details";
        if (path.includes('/new')) return "Add New";
        
        const basePath = '/' + path.split('/')[1];
        if (pageTitles[basePath]) return pageTitles[basePath];
        
        return (
            <img 
                src="/images/miniLogo.png" 
                className="w-16 sm:w-20 lg:w-24" 
                alt="DrEasy Logo"
            />
        );
    };

    const pageTitle = getPageTitle(location.pathname);

    useEffect(() => {
        const initializeSidebar = () => {
            if (!isInitialized) {
                const isDesktop = window.innerWidth >= 768;
                setSidebarOpen(isDesktop);
                setIsInitialized(true);
            }
        };

        initializeSidebar();
    }, [isInitialized]);

    useEffect(() => {
        if (!isInitialized) return;

        const handleResize = () => {
            if (window.innerWidth >= 768) { 
                setSidebarOpen(true); 
            } else {
                setSidebarOpen(false); 
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isInitialized]);

    useEffect(() => {
        if (isMobile && sidebarOpen) {
            setSidebarOpen(false);
        }
    }, [location.pathname, isMobile]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    if (!isInitialized) {
        return <div className="min-h-screen bg-gray-50" />
    }

    return (
        <div className="min-h-screen bg-gray-50 flex">
            <Sidebar
                isOpen={sidebarOpen}
                onToggle={toggleSidebar}
                user={data}
                isLoading={isLoading}
            />

            <div className={`flex-1 flex flex-col transition-all duration-300 min-w-0
                ${isMobile ? 'ml-0' : sidebarOpen ? 'ml-64' : 'ml-16'}`}>
                
                <Header 
                    user={data} 
                    isLoading={isLoading} 
                    toggleSidebar={toggleSidebar} 
                    title={pageTitle} 
                />
                <NetworkStatusAlert />

                <main className="flex-1 px-2 md:px-4     overflow-x-hidden">
                    <div className="max-w-full">
                        <Outlet />
                        {children}
                    </div>
                </main>

                <div className="h-16 sm:h-0" />
            </div>

         
        </div>
    );
};

export default Layout;